import { render, staticRenderFns } from "./OrderAttachments.vue?vue&type=template&id=344f90ce&scoped=true&"
import script from "./OrderAttachments.vue?vue&type=script&lang=js&"
export * from "./OrderAttachments.vue?vue&type=script&lang=js&"
import style0 from "./OrderAttachments.vue?vue&type=style&index=0&id=344f90ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344f90ce",
  null
  
)

export default component.exports